import { Link } from 'react-router-dom'
import {
  articelsHomePageImages,
  images,
} from '../../services/images.service'
import { getAnimeDetailsUrl, getAnimeImage } from '../../services/util.service'
import { useEffect, useMemo, useRef, useState } from 'react'
import Slider from 'react-slick'
import { RelatedPost } from './RelatedPost'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { MalScore } from '../../assets/imgs/svg/AnimeDetails/desktop/MalScore'
import { IsraelScore } from '../../assets/imgs/svg/AnimeDetails/desktop/IsraelScore'
import { fetchAnimesByIds } from '../../store/slices/animeDB.slice'
import { ArrowLeft, ArrowRight } from '../ui/icons/shared'
import { GreyBorderBottom } from '../ui/elements'

export function AnimeInfo({ anime, reviews }) {
  const [hoveredAnimeId, setHoveredAnimeId] = useState(null)
  const [plusHoveredItems, setPlusHoveredItems] = useState({})

  const dispatch = useDispatch()
  const { relationsData } = useSelector((state) => state.animeDB) // שמירת המידע ב־redux

  useEffect(() => {
    if (!anime || !anime.relations) return

    const relationIds = anime.relations.flatMap((rel) =>
      rel.entry.map((entry) => entry.mal_id)
    )

    if (relationIds.length) {
      dispatch(fetchAnimesByIds(relationIds))
    }
  }, [anime, dispatch])

  const averageRating = useMemo(() => {
    if (!reviews.length) return 0
    const total = reviews.reduce((sum, review) => sum + review.rating, 0)
    return (total / reviews.length).toFixed(2) // דיוק של עשירית
  }, [reviews])

  const sliderRef = useRef(null)

  const animeCount = anime.relations?.length || anime.similarAnime?.length || 1
  const slidesToShowCount = Math.min(4, animeCount) // יתאים את מספר השקופיות לכמות האובייקטים בפועל

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: slidesToShowCount > 1, // ביטול אינסוף אם יש רק אובייקט אחד
    autoplay: slidesToShowCount > 1, // ביטול autoplay אם יש רק אחד
    autoplaySpeed: 5000,
    cssEase: 'linear',
    pauseOnHover: true,
    pauseOnFocus: true,
    speed: 600,
    slidesToShow: slidesToShowCount, // ✅ שינוי דינמי
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: Math.min(3, animeCount) } },
      { breakpoint: 1024, settings: { slidesToShow: Math.min(2, animeCount) } },
      { breakpoint: 768, settings: { slidesToShow: Math.min(1, animeCount) } },
    ],
  }

  return (
    <section className="flex flex-col w-full gap-14">
      <div className="flex justify-between h-[106px]">
        <div
          className="h-full flex items-center justify-center p-10 bg-gradient-to-tr from-[#252525] to-[#1B1B1B] shadow-[0px_0px_2.1px_0px_rgba(0,0,0,0.56)]"
          style={{
            borderBottomWidth: '2px', // עובי הגבול
            borderBottomStyle: 'solid', // חובה להגדיר סגנון גבול
            borderImageSource: `url(${images.redBorder})`, // מקור תמונת הגבול
            borderImageSlice: '20', // קובע חיתוך לתמונה
            borderImageRepeat: 'stretch', // למתוח את התמונה כך שתמלא את הגבול
          }}
        >
          {' '}
          <div className="flex gap-2">
            <div className="flex flex-col gap-4">
              <MalScore />

              <div className="text-center text-lg">
                <span className="text-muted">10 / </span>{' '}
                <span className="text-softText">{anime.score || 0}</span>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <IsraelScore />

              <div className="text-center text-lg">
                <span className="text-muted">10 / </span>{' '}
                <span className="text-softText">{averageRating}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex gap-4">
          <div
            className="h-full flex items-center justify-center p-10 bg-gradient-to-tr from-[#252525] to-[#1B1B1B] shadow-[0px_0px_2.1px_0px_rgba(0,0,0,0.56)]"
            style={{
              borderBottomWidth: '2px', // עובי הגבול
              borderBottomStyle: 'solid', // חובה להגדיר סגנון גבול
              borderImageSource: `url(${images.redBorder})`, // מקור תמונת הגבול
              borderImageSlice: '20', // קובע חיתוך לתמונה
              borderImageRepeat: 'stretch', // למתוח את התמונה כך שתמלא את הגבול
            }}
          >
            {' '}
            <div className="flex flex-col gap-4 text-center text-softText text-sm">
              <span>דירוג</span>#{anime.rank}
            </div>
          </div>

          <div
            className="h-full flex items-center justify-center p-10 bg-gradient-to-tr from-[#252525] to-[#1B1B1B] shadow-[0px_0px_2.1px_0px_rgba(0,0,0,0.56)]"
            style={{
              borderBottomWidth: '2px', // עובי הגבול
              borderBottomStyle: 'solid', // חובה להגדיר סגנון גבול
              borderImageSource: `url(${images.redBorder})`, // מקור תמונת הגבול
              borderImageSlice: '20', // קובע חיתוך לתמונה
              borderImageRepeat: 'stretch', // למתוח את התמונה כך שתמלא את הגבול
            }}
          >
            {' '}
            <div className="flex flex-col gap-4 text-center text-softText text-sm">
              <span>פופולריות</span>#{anime.popularity}
            </div>
          </div>

          <div
            className="h-full flex items-center justify-center p-10 bg-gradient-to-tr from-[#252525] to-[#1B1B1B] shadow-[0px_0px_2.1px_0px_rgba(0,0,0,0.56)]"
            style={{
              borderBottomWidth: '2px', // עובי הגבול
              borderBottomStyle: 'solid', // חובה להגדיר סגנון גבול
              borderImageSource: `url(${images.redBorder})`, // מקור תמונת הגבול
              borderImageSlice: '20', // קובע חיתוך לתמונה
              borderImageRepeat: 'stretch', // למתוח את התמונה כך שתמלא את הגבול
            }}
          >
            {' '}
            <div className="flex flex-col gap-4 text-center text-softText text-sm">
              <span>צופים</span>
              {Intl.NumberFormat('he-IL').format(anime.members)}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <div>
          <h5>תקציר</h5>
       <GreyBorderBottom className="w-full" />
        </div>

        <p className="text-softText text-lg w-[90%]">
          {anime.synopsis_hebrew || anime.synopsis || 'אין תקציר זמין'}
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <h5>רקע</h5>
          <GreyBorderBottom className="w-full" />
        </div>

        <p className="text-softText text-lg w-[90%]">
          {anime.background_hebrew || anime.background || 'אין רקע זמין'}
        </p>
      </div>

      {/* ✅ הצגת אנימות דומות */}
      {anime.similarAnime && anime.similarAnime.length > 0 && (
        <div>
          <div className="flex flex-col gap-4">
            <div>
              <h5>אנימות דומות</h5>
              <GreyBorderBottom className="w-full" />
            </div>
          </div>

          {/* 🔹 כפתורי ניווט */}

          <div className="flex mt-4 justify-between">
            <div className="w-[90%]">
              {/* 🔹 קרוסלת האנימות */}

              <Slider {...sliderSettings} ref={sliderRef}>
                {anime.relations && anime.relations.length > 0 ? (
                  anime.relations.flatMap((relation) =>
                    relation.entry
                      // .filter((entry) => entry.type === 'anime')
                      .map((entry) => {
                        const animeData = relationsData[entry.mal_id] || {} // טעינת נתונים מה־Redux
                        const imageSrc = getAnimeImage(animeData)

                        const title_hebrew = animeData?.title_hebrew || ''
                        const title = entry.name
                        const altTitle = `${title_hebrew} // ${title}`

                        const isSingleAnime =
                          anime.relations?.length === 1 ||
                          anime.similarAnime?.length === 1
                        return (
                          <div
                            key={entry.mal_id}
                            className={`flex flex-col items-center px-2 transition-all duration-300 ${
                              isSingleAnime ? 'w-[200px]' : 'w-full'
                            }`}
                          >
                            {/* ✅ אם זה ANIME - קישור רגיל */}
                            {entry.type === 'anime' ? (
                              <Link
                                to={getAnimeDetailsUrl(entry)}
                                className="block w-full"
                              >
                                <img
                                  src={imageSrc}
                                  alt={altTitle}
                                  className={`h-[320px] object-cover rounded transition-transform duration-300 hover:scale-105 ${
                                    isSingleAnime ? 'w-[200px]' : 'w-full'
                                  }`}
                                />
                              </Link>
                            ) : (
                              // ❌ אם זה MANGA - ללא קישור + הצגת TOAST בלחיצה
                              <img
                                src={imageSrc}
                                alt={altTitle}
                                className={`h-[320px] object-cover rounded transition-transform duration-300 hover:scale-105 cursor-pointer ${
                                  isSingleAnime ? 'w-[200px]' : 'w-full'
                                }`}
                                onClick={() =>
                                  toast.error(
                                    'כרגע אין מידע זמין על מנגות באתר'
                                  )
                                }
                              />
                            )}

                            <div
                              className={`flex flex-col items-center text-center bg-secondaryBackground p-4 ${
                                isSingleAnime ? 'w-[200px]' : 'w-full'
                              }`}
                            >
                              <p
                                className="text-white rtl-truncate max-w-full"
                                title={altTitle}
                              >
                                <span> {title_hebrew}</span> //{' '}
                                <span>{title}</span>
                              </p>
                            </div>
                          </div>
                        )
                      })
                  )
                ) : // ❌ Fallback - אם אין `relations`, מציג כותרות דומות
                anime.similarAnime && anime.similarAnime.length > 0 ? (
                  anime.similarAnime.map((animeItem) => {
                    const title_hebrew = animeItem?.title_hebrew || ''
                    const title = animeItem.title_english || animeItem.title

                    const altTitle = `${title_hebrew} // ${title}`

                    return (
                      <div
                        key={animeItem.mal_id}
                        className="flex flex-col items-center px-2 transition-all duration-300"
                      >
                        <Link
                          to={getAnimeDetailsUrl(animeItem)}
                          className="block w-full"
                        >
                          <img
                            src={getAnimeImage(animeItem)}
                            alt={altTitle}
                            className="w-full h-[320px] object-cover rounded transition-transform duration-300 hover:scale-105"
                          />
                        </Link>

                        <div className="w-full flex flex-col items-center text-center bg-secondaryBackground p-4">
                          <p
                            className="text-white rtl-truncate max-w-full"
                            title={altTitle}
                          >
                            <span> {title_hebrew}</span> // <span>{title}</span>
                          </p>
                        </div>
                      </div>
                    )
                  })
                ) : (
                  // 🛑 אם אין גם `similarAnime` - הצגת הודעה שאין נתונים
                  <p className="text-white text-center w-full">
                    אין נתונים זמינים
                  </p>
                )}
              </Slider>
            </div>
            <div className="justify-center flex flex-col items-center">
              <button onClick={() => sliderRef.current.slickPrev()}>
                <ArrowLeft />
              </button>
              <button onClick={() => sliderRef.current.slickNext()}>
                <ArrowRight />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ הצגת דמויות */}
      {anime.characters && anime.characters.length > 0 && (
        <div className="">
          {/* 🔹 כותרת */}
          <div className="mb-4">
            <h5>דמויות ומדבבים</h5>
            <GreyBorderBottom className="w-full" />
          </div>

          {/* 🔹 טבלה עם דמויות ומדובבים */}
          <div className="grid grid-cols-2 gap-4">
            {anime.characters.map((character, index) => {
              // ✅ מחשב מספר השורה לפי מספר העמודות (2)
              const rowIndex = Math.floor(index / 2)
              const bgColor =
                rowIndex % 2 === 0 ? 'bg-[#363636]' : 'bg-[#1F1F1F]'

              return (
                <div
                  key={character.character_mal_id || index}
                  className={`flex items-center gap-4 ${bgColor}`}
                >
                  {/* 🔹 תמונת הדמות */}
                  <img
                    src={
                      character.images?.image_url ||
                      'https://placehold.co/150X180'
                    }
                    alt={character.name}
                    className="w-14 h-20 object-cover"
                  />

                  {/* 🔹 פרטי הדמות */}
                  <div className="flex-1">
                    <p className="text-lg font-bold text-softText">
                      {character.name}
                    </p>
                    <p className="text-gray-400 text-sm">{character.role}</p>
                  </div>

                  {/* 🔹 פרטי המדובב */}
                  {character.voice_actors?.length > 0 && (
                    <div className="flex gap-2 items-center">
                      <div className="flex flex-col items-end">
                        <p className="text-lg font-bold text-softText">
                          {character.voice_actors[0].name}
                        </p>
                        <p className="text-gray-400 text-xs">
                          {character.voice_actors[0].language}
                        </p>
                      </div>

                      {/* 🔹 תמונת המדובב */}
                      <img
                        src={character.voice_actors[0].image}
                        alt={character.voice_actors[0].name}
                        className="w-14 h-20 object-cover mt-1"
                      />
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* ✅ הצגת במאים */}
      {anime.directors && anime.directors.length > 0 && (
        <div className="">
          <div className="mb-4">
            <h5>מפיקים</h5>
            <GreyBorderBottom className="w-full" />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2">
            {anime.directors.map((director) => (
              <div
                key={director.staff_mal_id || index}
                className="flex items-center gap-2"
              >
                <img
                  src={director.image}
                  alt={director.name}
                  className="w-10 h-16 object-cover"
                />
                <div className="flex flex-col">
                  <p className="w-full">{director.name}</p>
                  <p className="text-gray-400 text-sm">
                    {director.positions.join(', ')}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <RelatedPost anime={anime} />
    </section>
  )
}
